import { TeamMemberHistory } from './TeamMemberHistory';

export default TeamMemberHistory;
